import styled from 'styled-components';
import TextareaAutosize from 'react-autosize-textarea';

export const Wrapper = styled.div`
  row-gap: 10px;
  column-gap: 6px;
  align-items: flex-start;
  grid-template-rows: auto 1fr min-content;
  grid-template-columns: auto min-content;
  display: grid;
  
  box-sizing: border-box;
  padding: 10px;
  
  min-height: 240px;
  border-radius: 5px;
  background: ${({theme}) => `
    ${theme.variables.backgroundColor};
  `};
`;

export const Title = styled(TextareaAutosize)`
  margin-top: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

export const Controls = styled.div`
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Words = styled.div`
  grid-column: span 2;
`;

export const InputContainer = styled.div`
  grid-column: span 2;
`;
